import React, { useState } from "react";
import { projectyle, appStyle } from '../utils/styles';
import { Modal } from '../components/modal/modal';
import {englishIcon, granjaImg, mePhoto,ortografiaImg,phoneimg,prestamosImg,scriptIcon,seguridadImg,spanishIcon,sqlIcon} from '../components/images';
import '../Proyectos.css';
export function Myprojects({ language, setShowAlert }) {


   const data = {
      en: {
         title: "Project (1)",
         title2: "Ortografía-Básica",
         category: 'Category: Mobile App',
         description: 'Description: Developed an Android mobile app designed to help users improve their Spanish spelling skills. The app includes features such as Notes, Dictionary, Chat, and Exercise modules, providing a comprehensive learning experience. With the latest update, the app saw a significant increase in user acquisition from 10% to 80%, alongside a 65% reduction in user churn.',
         frontendTechnology: 'Frontend: Javascript, React, React Native, CSS, Git',
         backendTechnology: 'Backend: Firebase, Node, Express',
         authors: 'Authors: Eric Joel Marte',
      },
      es: {
         title: "Proyecto (1)",
         title2: "Ortografía-Básica",
         category: 'Categoría: Aplicación Móvil',
         description: 'Descripción: Descripción: Desarrollé una aplicación móvil para Android diseñada para ayudar a los usuarios a mejorar sus habilidades de ortografía en español. La aplicación incluye funciones como módulos de Notas, Diccionario, Chat y Ejercicio, lo que brinda una experiencia de aprendizaje integral. Con la última actualización, la aplicación experimentó un aumento significativo en la adquisición de usuarios del 10% al 80%, junto con una reducción del 65% en la rotación de usuarios.',
         frontendTechnology: 'Frontend: Javascript, React, React Native, CSS, Git',
         backendTechnology: 'Backend: Firebase, Node, Express',
         authors: 'Autores: Eric Joel Marte',
      }

   }

const proyectosData = [
  { id: 1, titulo: "Ortografía-Básica", tech: "Javascript, React, React Native, CSS, Git, Firebase, Node, Express", img: ortografiaImg },
  { id: 2, titulo: "Granja M&D", tech: " Javascript, React, React Native, CSS, Git, Node, Firebase", img: granjaImg },
  { id: 3, titulo: "Urban Security", tech: "Javascript, React, React Native, CSS, Git, Node, Express, Google Apps Script", img: seguridadImg },
  { id: 4, titulo: "Phone App", tech: "HTML, CSS, Javascript, React, Twilio SDK, Tauri, Git, Node, Express, Twilio Firebase", img: phoneimg }
];

function certificaciones({ type, show }) {

      if (type === "code" && !show) {

         setShowAlert(true);
         return;
      }
      window.open("https://play.google.com/store/apps/details?id=com.ericjoel.OrtografiaBasica&pcampaignid=web_share", "_blank");

   }

   
   return (
     <section className="proyectos-section">
      <div className="container-header">
        <h2 className="titulo-seccion">Mis Proyectos</h2>
      </div>

      <div className="carrusel-nativo">
        {proyectosData.map((proyecto) => (
          <div key={proyecto.id} className="proyecto-card">
            <div className="img-container">
              <img src={proyecto.img} alt={proyecto.titulo} />
            </div>
            <div className="proyecto-info">
              <h3>{proyecto.titulo}</h3>
              <p>{proyecto.tech}</p>
              <div className="proyecto-buttons">
                <button className="btn-demo">Demo</button>
                <button className="btn-github">GitHub</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>


   )
}